import React, { useEffect, useState } from "react";
import "./Header.css";
import icono from "../images/icono.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [changeColor, setChangeColor] = useState("");
  const headerStick = () => {
    if (document.documentElement.scrollTop !== 0) {
      setChangeColor("blue");
    } else {
      setChangeColor("blue2");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", headerStick);
  }, []);
  return (
    <header className="notSticky">
      <div className={`content-header `}>
        <div className={`contet-buttons-and-title ${changeColor}`}>
          <Link to="/">
            <div className="title">
              <img src={icono} alt="icono" height={40} width={40} />
              <h2>We Care You</h2>
            </div>
          </Link>
          <div className="content-buttons">
            <input type="checkbox" id="check" />
            <label htmlFor="check" className="checkbtn">
              <img
                src="data:image/png;base64,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"
                width="30"
                height="20"
                alt="xd"
              />
            </label>
            <div className="buttons-header">
              <Link to="/crear">
                <button className="btn">Obtener un turno</button>
              </Link>
              <Link to="/turnos">
                <button className="btn">Mis turnos</button>
              </Link>
              <Link to="/doctores">
                <button className="btn">Doctores</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="numbers">
          <div>
            <button className="contacts-buttons">
              <svg width="30px" height="30px" viewBox="0 0 500 500">
                <g>
                  <path d="M366.667,300c-33.334,33.333-33.334,66.666-66.667,66.666S233.333,333.333,200,300   c-33.333-33.334-66.667-66.667-66.667-100c0-33.333,33.333-33.333,66.667-66.667S133.333,0,100,0S0,100,0,100   c0,66.667,68.49,201.823,133.333,266.667S333.333,500,400,500c0,0,100-66.667,100-100C500,366.667,400,266.667,366.667,300z" />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </button>
            <p>Atencion telefonica</p>
            <p>
              <b>(123)456789</b>
            </p>
          </div>
          <div>
            <button className="contacts-buttons">
              <svg width="30" height="30" viewBox="0 0 256 256">
                <defs></defs>
                <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                  <path
                    d="M 76.735 13.079 C 68.315 4.649 57.117 0.005 45.187 0 C 20.605 0 0.599 20.005 0.589 44.594 c -0.003 7.86 2.05 15.532 5.953 22.296 L 0.215 90 l 23.642 -6.202 c 6.514 3.553 13.848 5.426 21.312 5.428 h 0.018 c 0.001 0 -0.001 0 0 0 c 24.579 0 44.587 -20.007 44.597 -44.597 C 89.789 32.713 85.155 21.509 76.735 13.079 z M 27.076 46.217 c -0.557 -0.744 -4.55 -6.042 -4.55 -11.527 c 0 -5.485 2.879 -8.181 3.9 -9.296 c 1.021 -1.115 2.229 -1.394 2.972 -1.394 s 1.487 0.007 2.136 0.039 c 0.684 0.035 1.603 -0.26 2.507 1.913 c 0.929 2.231 3.157 7.717 3.436 8.274 c 0.279 0.558 0.464 1.208 0.093 1.952 c -0.371 0.743 -0.557 1.208 -1.114 1.859 c -0.557 0.651 -1.17 1.453 -1.672 1.952 c -0.558 0.556 -1.139 1.159 -0.489 2.274 c 0.65 1.116 2.886 4.765 6.199 7.72 c 4.256 3.797 7.847 4.973 8.961 5.531 c 1.114 0.558 1.764 0.465 2.414 -0.279 c 0.65 -0.744 2.786 -3.254 3.529 -4.369 c 0.743 -1.115 1.486 -0.929 2.507 -0.558 c 1.022 0.372 6.5 3.068 7.614 3.625 c 1.114 0.558 1.857 0.837 2.136 1.302 c 0.279 0.465 0.279 2.696 -0.65 5.299 c -0.929 2.603 -5.381 4.979 -7.522 5.298 c -1.92 0.287 -4.349 0.407 -7.019 -0.442 c -1.618 -0.513 -3.694 -1.199 -6.353 -2.347 C 34.934 58.216 27.634 46.961 27.076 46.217 z"
                    transform=" matrix(1 0 0 1 0 0) "
                    stroke-linecap="round"
                  />
                </g>
              </svg>
            </button>
            <p>Atencion por Whatsapp</p>
            <p>
              <b>(987)654321</b>
            </p>
          </div>
          <div>
            <button className="contacts-buttons">
              <svg height="30" width="30" viewBox="0 0 305.616 305.616">
                <g>
                  <path d="M24.818,260.333c-24.459,0-0.397-24.818-0.397-24.818l62.359-68.532   c6.065-6.663,17.769-16.78,24.612-11.199c6.842,5.58,15.98,16.888,22.344,23.268l12.896,12.907c6.913,6.119,12.232,0,12.232,0   l13.195-12.999c6.418-6.326,15.61-17.362,22.463-22.496c6.853-5.134,18.509,4.629,24.557,11.308l61.994,68.5   c24.47,24.062,0.397,24.062,0.397,24.062H24.818z M35.403,203.951c-6.065,6.668-14.925,18.264-20.913,24.998   C7.729,236.548,0,242.318,0,229.009L0.294,95.311c0.022-9.013-0.228-26.2,5.929-23.116c2.29,1.148,5.423,3.535,9.676,7.794   l50.464,41.288c6.973,5.706,16.801,12.689,20.016,17.34c2.029,2.932,2.959,6.342,0.022,9.29L35.403,203.951z M171.423,156.452   c-6.967,5.716-14.539,13.826-18.406,13.837c-3.867,0.005-11.58-7.919-18.58-13.598L24.634,67.621   c-7-5.673-19.058-17.1-13.065-20.163c4.329-2.214,11.895-2.176,11.895-2.176h258.029c23.23,0,11.417,11.471,11.417,11.471   L171.423,156.452z M291.11,228.949c-5.999-6.728-14.865-18.33-20.924-24.998l-50.969-56.05c-2.953-2.948-2.029-6.358,0-9.29   c3.214-4.65,13.048-11.629,20.027-17.334l37.845-30.959c6.973-5.706,16.143-15.039,22.295-18.123   c6.152-3.084,5.885,14.109,5.907,23.116l0.326,133.698C305.621,242.318,297.881,236.548,291.11,228.949z" />
                </g>
              </svg>
            </button>
            <p>Correo Electronico</p>
            <p>
              <b>emaildepreuba@wecareyou.com</b>
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
